<spb-disclaimer/>
<!-- We need this div to make sure we inherit styling -->
<div>
  <router-outlet name="item"/>
</div>

<spb-document/>

